var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmModal',_vm._b({attrs:{"color":"green","icon":"mdi-lock","maxWidth":500,"itemKey":"Ticket","fetchData":_vm.fetchData,"setTitle":_vm.setTitle,"setQuestion":_vm.setQuestion,"confirmData":_vm.closeData},on:{"onConfirm":(response) => _vm.$emit('onClose', response)}},'ConfirmModal',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }